import { AdvancedSearchFiltersController } from './advanced-search-filters.controller'

function advancedSearchFilters () {
  return {
    restrict: 'E',
    scope: {
      locale: '<',
      filters: '=',
      value: '=',
      filtersCount: '=',
      isOpen: '=',
      onSubmit: '<',
      onCount: '<',
      saveFilter: '<',
      onSaveFilter: '<'
    },
    templateUrl: '/core/directives/advanced-search-filters/advanced-search-filters.html?$$REVISION$$',
    controller: AdvancedSearchFiltersController
  }
}
export { advancedSearchFilters }
